import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "footer-content" }
const _hoisted_3 = { class: "footer-section" }


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

// Footer component - no reactive logic needed

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "footer-section" }, [
          _createElementVNode("h3", null, "Space Coast STEM"),
          _createElementVNode("p", null, "Empowering students in Brevard County through technology and education.")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("h4", null, "Quick Links", -1)),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/about" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("About Us", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/get-involved" }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Get Involved", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/contact" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Contact", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "footer-section" }, [
          _createElementVNode("h4", null, "Contact"),
          _createElementVNode("p", null, "Email: info@spacecoaststem.org"),
          _createElementVNode("p", null, "Brevard County, Florida")
        ], -1))
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "footer-bottom" }, [
        _createElementVNode("p", null, "© 2025 Space Coast STEM Inc. All rights reserved")
      ], -1))
    ])
  ]))
}
}

})